@reference "../../../style/base.css";

.toolPlayController {
  @apply w-full justify-center border-t border-gray-400 bg-white text-body-lg;
}

.toolPlayController__wrapper {
  @apply max-w-full flex-1 flex-col justify-center divide-y border-gray-500;
}

.toolPlayController__top {
  @apply w-screen items-center justify-center text-body-md;
}

.toolPlayController__top__frame-move,
.toolPlayController__top__task-move {
  @apply w-24 min-w-24;
}

.toolPlayController__bottom {
  @apply w-screen;
}

.toolPlayController__bottom__frame-move {
  @apply w-[288px] min-w-[288px];
}

.toolPlayController__bottom__task-move {
  @apply w-24 min-w-24;
}

.toolPlayController__buttonsWrapper {
  @apply divide-x border-gray-400;
}

.toolPlayController__buttons {
  @apply px-4;
}

.toolPlayController__button,
.toolPlayController__progressBar,
.toolPlayController__frameInfo,
.toolPlayController__interval {
  @apply flex items-center;
}

.toolPlayController__progressBar {
  @apply w-80;
}

.toolPlayController__frameInfo,
.toolPlayController__interval {
  @apply gap-2 pl-2 text-body-lg text-gray-600;
}

.toolPlayController input {
  @apply w-16 rounded-sm border border-gray-400 px-2 py-1 text-body-md focus:border-blue-300;
}

.toolPlayControllerFrameBar {
  @apply h-12 border-b border-gray-400 px-2 select-none;
  @apply flex-1 overflow-x-auto;
}
